import React, { useEffect, useState, useRef } from "react";
import image1 from "../../assests/loginpage-image.png";
import { getLogoBySubdomain } from "../../services/white_label";
export default function SignupSidebar() {
  const headings = [
    "Empower your *career journey",
    "The path towards *success",
    "*Challenging real-world questions",
    "Personalized *learning road-map",
    "Customized *Resume *Builder",
  ];

  const texts = [
    "Reaidy.io, Al-driven interview bot, that offer realistic mock interviews.     ",
    "Al mock interviews to sharpen your skills and Career advancements.     ",
    "Realistic simulation and preparation on demand with diverse interview scenarios.      ",
    "An efficient journey towards your career goals with efficient progression.      ",
    "Highlight your skills with Professional templates and Guided success path.        ",
  ];

  const [currentHeadingIndex, setCurrentHeadingIndex] = useState(0);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [textIndex, setTextIndex] = useState(0);

  const intervalIdRef = useRef(null);

  useEffect(() => {
    const changeContent = () => {
      setCurrentHeadingIndex((prevIndex) => (prevIndex + 1) % headings.length);
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
      setTextIndex(0);
      setDisplayedText("");
    };

    const typeText = () => {
      if (textIndex < texts[currentTextIndex].length) {
        setDisplayedText(
          (prevText) => prevText + texts[currentTextIndex][textIndex]
        );
        setTextIndex((prevIndex) => prevIndex + 1);
      } else {
        changeContent();
      }
    };

    clearInterval(intervalIdRef.current);
    intervalIdRef.current = setInterval(typeText, 60);

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, [textIndex, currentTextIndex]);

  // Extracting the first word and the rest of the heading
  const words = headings[currentHeadingIndex].split(" ");

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center text-white gil-reg relative">
      <div className=" text-white">
        <img src={getLogoBySubdomain()} alt="" className="w-52 mb-6 " />
        <h1 className="text-5xl font-bold pb-4">
          {words.map((word, index) => (
            <span
              key={index}
              className={word.startsWith("*") ? "text-primary" : ""}
            >
              {word.replace("*", "")}{" "}
            </span>
          ))}
        </h1>
      </div>
      <p className="text-xl h-20">{displayedText}</p>
      <div className="absolute left-5 bottom-5 opacity-50 ">
        <img src={image1} alt=" sitting image" className="w-48" />
      </div>
    </div>
  );
}
